<template>
    <div>
        <div class="section01">
            <h3 class="head_layout">
                백신 접종 현황
                <span class="chart" style="cursor: pointer;"
                      @click.prevent="showCovidChartWin(true)"></span>
                <span class="plus" style="cursor: pointer;"
                      @click.prevent="goPage"></span>
                <span style="cursor: pointer;"
                      :class="isRolling ? 'stop' : 'play'"
                      @click.prevent="rollingChange"></span>
            </h3>
            <div class="today-weather">
                {{ latestVaccination.basdtVal | ymd }} {{ latestVaccination.val8 }}시 기준
            </div>
            <!-- <div class="corona-box-wrap">
                <div class="corona-inbox">
                    <p class="tit">
                        1차 <span class="f_white">({{ latestVaccination.val4 }}%)</span>
                        <span :class="firstDiffVaccinationCntInfo.class">
                        ({{ firstDiffVaccinationCntInfo.flag }}{{ firstDiffVaccinationCntInfo.diff !== 0 ? firstDiffVaccinationCntInfo.diff : '' }})
                        </span>
                    </p>

                    <ul class="cont">
                        <li>
                            <span>{{ latestVaccination.val2 | currency }}</span>명
                            <p>접종 대상자</p>
                        </li>
                        <li>
                            <span class="f_orenge">{{ latestVaccination.val3 | currency }}</span>명
                            <p>접종자</p>
                        </li>
                    </ul>
                </div>
                <div class="corona-inbox">
                    <p class="tit">
                        2차 <span class="f_white">({{ latestVaccination.val7 }}%)</span>
                        <span :class="secondDiffVaccinationCntInfo.class">
                        ({{ secondDiffVaccinationCntInfo.flag }}{{ secondDiffVaccinationCntInfo.diff !== 0 ? secondDiffVaccinationCntInfo.diff : '' }})
                        </span>
                    </p>
                    <ul class="cont">
                        <li>
                            <span>{{ latestVaccination.val5 | currency }}</span>명
                            <p>접종 대상자</p>
                        </li>
                        <li>
                            <span class="f_orenge">{{ latestVaccination.val6 | currency }}</span>명
                            <p>접종자</p>
                        </li>
                    </ul>
                </div>
            </div> -->
            <div class="corona-box-wrap2">
                <div class="corona-inbox2 total_people">
                    인구 <span class="cnt">{{ latestVaccination.val2 | currency }}</span> 명
                </div>
                <div class="corona-inbox2">
                    <p class="tit">1차 <span class="f_white">({{ latestVaccination.val4 }}%)</span></p>
                    <ul class="cont">
                        <li>
                            <span>{{ latestVaccination.val9 | currency }}</span>명
                            <p>신규접종자</p>
                        </li>
                        <li>
                            <span class="f_orenge">{{ latestVaccination.val3 | currency }}</span>명
                            <p>누적접종자</p>
                        </li>
                    </ul>
                </div>
                <div class="corona-inbox2">
                    <p class="tit">2차 <span class="f_white">({{ latestVaccination.val7 }}%)</span></p>
                    <ul class="cont">
                        <li>
                            <span>{{ latestVaccination.val10 | currency }}</span>명
                            <p>신규접종자</p>
                        </li>
                        <li>
                            <span class="f_orenge">{{ latestVaccination.val6 | currency }}</span>명
                            <p>누적접종자</p>
                        </li>
                    </ul>
                </div>
                <div class="corona-inbox2">
                    <p class="tit">3차 <span class="f_white">({{ latestVaccination.val14 }}%)</span></p>
                    <ul class="cont">
                        <li>
                            <span>{{ latestVaccination.val11 | currency }}</span>명
                            <p>신규접종자</p>
                        </li>
                        <li>
                            <span class="f_orenge">{{ latestVaccination.val13 | currency }}</span>명
                            <p>누적접종자</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <transition name="modal">
            <CovidVaccinationChartWin v-if="isShowCovidChartWin" @close-covid-chart-win="showCovidChartWin(false)"/>
        </transition>
    </div>
</template>

<script>
import Covid19Mixin from '@/store/covid19.mixin.js';
import CovidVaccinationChartWin from '@/views/realtime/CovidVaccinationChartWin.vue';

export default {
    name: 'CovidVaccinationSummary',
    props: {
        isRolling: {
            type: Boolean,
            default: true,
        }
    },
    data () {
        return {
            isShowCovidChartWin: false,
        }
    },
    methods: {
        showCovidChartWin (isShow) {
            this.isShowCovidChartWin = isShow

            if(isShow) {
                this.$emit('chart-activated');
            } else {
                this.$emit('chart-deactivated');
            }
        },
        rollingChange() {
            this.$emit('change-rolling-click');
        },
        goPage() {
            window.open('https://www.ep.go.kr/CmsWeb/viewPage.req?idx=PG0000004918', '_blank')
        }
    },
    components: {
        CovidVaccinationChartWin,
    },
    mixins: [Covid19Mixin],
}
</script>
